export const user = {
  name: "Abraham",
  username: "abraham638",
  profileImage: "/profile.png",
  followers: 567,
  likesReceived: 68,
  mentions: 2,
  description:
    "MEOW is an NFT platform for creating and trading digital assets.",
  privateKey: "2oBKcKs7Q19BBjeUGKd6S2SFvrpTsd2kDgnoYXuBYHep",
};

// export const user  = null

export const userById = {
  name: "Abraham Other",
  username: "abraham638",
  profileImage: "/profile.png",
  followers: 567,
  likesReceived: 68,
  mentions: 2,
  description:
    "MEOW is an NFT platform for creating and trading digital assets.",
  privateKey: "2oBKcKs7Q19BBjeUGKd6S2SFvrpTsd2kDgnoYXuBYHep",
};

export const profileTabs = [
  { id: 1, title: "Coins Held" },
  { id: 2, title: "Coins Created" },
  { id: 3, title: "Followers" },
  { id: 4, title: "Following" },
];

export const holderDistributions = [
  { serial: "1.", name: "AoWerd (bonding curve)", value: 20.69 },
  { serial: "2.", name: "29EKwQ", value: 3.86 },
  { serial: "3.", name: "5ZZdKe", value: 2.86 },
  { serial: "4.", name: "38NMGA", value: 2.8 },
  { serial: "5.", name: "8pfhwz", value: 2.4 },
  { serial: "6.", name: "7iUezB", value: 2.18 },
  { serial: "7.", name: "7aVXh9", value: 2.06 },
  { serial: "8.", name: "7Z6Kny", value: 1.97 },
  { serial: "9.", name: "JEDgek", value: 1.84 },
  { serial: "10.", name: "HVSocC", value: 1.75 },
  { serial: "11.", name: "3eWxzu", value: 1.69 },
  { serial: "12.", name: "DG55ji", value: 1.62 },
  { serial: "13.", name: "EwA2ny", value: 1.27 },
  { serial: "14.", name: "Ed7MnU (dev)", value: 1.16 },
  { serial: "15.", name: "CASGJA", value: 1.15 },
  { serial: "16.", name: "Cbitgr", value: 1.14 },
  { serial: "17.", name: "8jccyD", value: 1.13 },
  { serial: "18.", name: "HxWjjk", value: 1.11 },
  { serial: "19.", name: "7mr45Y", value: 1.1 },
  { serial: "20.", name: "nj2Xt7", value: 1.05 },
];

export const cardSlider = [
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
  {
    image: "/advance-slider-image.png",
    topContent1: "Mc",
    topContent2: "$76.2k",
    centerContent1: "V",
    centerContent2: "$11.8k",
    timeImage: "/icons/time-icon.svg",
    bottomContent: "19m Ago",
  },
];

export const coinsHeld = [
  {
    tokenAddress: "DHuGeApmXBBwvk9g9kpvrN76RGnZhjF8XWGuMTUJH319",
    tokenName: "Bonnie / SOL",
    age: "33 second(s) ago",
    chainName: "solana",
    price: "0.00000194172079035364",
    volume: "40.3695264157",
    liquidity: "3834.9682",
    fdv: "1941.72",
    totalTransactions: "4",
    pricePercentage: { m5: "0.27", h1: "0.27", h6: "0.27", h24: "0.27" },
    Mcap: "0.00007838634873809514",
    CoinName: "Bonnie / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "HUHPP4ALqnTdRifqSRaPwJ143NFysqy9m1e2ebXvifRL",
    tokenName: "CHERRY / SOL",
    age: "33 second(s) ago",
    chainName: "solana",
    price: "0.847420343021173",
    volume: "12350.14",
    liquidity: "19242.5089",
    fdv: "8474203430",
    totalTransactions: "9",
    pricePercentage: { m5: "133.5", h1: "133.5", h6: "133.5", h24: "133.5" },
    Mcap: "10465.759875159509",
    CoinName: "CHERRY / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "3UmNkqbsRgvMjVWB6uHnkU9gLPXkHoV52DggJ7D261Gc",
    tokenName: "RSQ / SOL",
    age: "33 second(s) ago",
    chainName: "solana",
    price: "0.0427729118680769",
    volume: "2443.7952",
    liquidity: "2695.8076",
    fdv: "427729119",
    totalTransactions: "9",
    pricePercentage: {
      m5: "3299.3",
      h1: "3299.3",
      h6: "3299.3",
      h24: "3299.3",
    },
    Mcap: "104.52823671322936",
    CoinName: "RSQ / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "CGsVJcsieZD6EpDBR1KNWMxraBhutqWZWa3aWHjqWeFP",
    tokenName: "RZCAT / SOL",
    age: "1 minute(s) ago",
    chainName: "solana",
    price: "0.00000783836958608448",
    volume: "516.237404195",
    liquidity: "4171.3102",
    fdv: "7838.37",
    totalTransactions: "3",
    pricePercentage: { m5: "46.02", h1: "46.02", h6: "46.02", h24: "46.02" },
    Mcap: "0.004046459568241288",
    CoinName: "RZCAT / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "HxU5c7qGjD37qrdqMvSzHdnZSfPGFgesk7MMFs74pump",
    tokenName: "RЕТALЕR / SOL",
    age: "3 minute(s) ago",
    chainName: "solana",
    price: "0.00324533823536362",
    volume: "235812.548335009",
    liquidity: "213680.2026",
    fdv: "3245338",
    totalTransactions: "549",
    pricePercentage: {
      m5: "2242.23",
      h1: "2242.23",
      h6: "2242.23",
      h24: "2242.23",
    },
    Mcap: "765.2914794901365",
    CoinName: "RЕТALЕR / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "4vFYsUVvgEE9SuDx1M7b6gDJM1pbgxtyZNEbLXomVnns",
    tokenName: "BUBUS / SOL",
    age: "3 minute(s) ago",
    chainName: "solana",
    price: "0.0000109887926857058",
    volume: "2246.1512291421",
    liquidity: "18292.8654",
    fdv: "10988.79",
    totalTransactions: "44",
    pricePercentage: { m5: "9.42", h1: "9.42", h6: "9.42", h24: "9.42" },
    Mcap: "0.024682490197785803",
    CoinName: "BUBUS / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "8BHWeLKz1qGT6oraGmbAau8nHLQWQmw5vScmQtncft5r",
    tokenName: "Dragon Sun / SOL",
    age: "4 minute(s) ago",
    chainName: "solana",
    price: "0.000180811872693157",
    volume: "15016.2489198089",
    liquidity: "65191.9976",
    fdv: "128376",
    totalTransactions: "27",
    pricePercentage: { m5: "204", h1: "204", h6: "204", h24: "204" },
    Mcap: "2.7151160880172434",
    CoinName: "Dragon Sun / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "E4pbuVJfbHomMw6pCTLyPXnhMmL7JP6ucLLR1n6v11uP",
    tokenName: "LEOAI / SOL",
    age: "4 minute(s) ago",
    chainName: "solana",
    price: "0.127494258148617",
    volume: "61602.5040986109",
    liquidity: "75475.3895",
    fdv: "127494258",
    totalTransactions: "603",
    pricePercentage: {
      m5: "411.37",
      h1: "411.37",
      h6: "411.37",
      h24: "411.37",
    },
    Mcap: "7853.965560149535",
    CoinName: "LEOAI / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "GR3GXFGjsPxo8AGVXoREj4b6QembH3r8QeZJFEcmjWam",
    tokenName: "HFK / SOL",
    age: "4 minute(s) ago",
    chainName: "solana",
    price: "0.0913448388602034",
    volume: "3828.47732",
    liquidity: "6891.5962",
    fdv: "913448389",
    totalTransactions: "12",
    pricePercentage: {
      m5: "1547.57",
      h1: "1547.57",
      h6: "1547.57",
      h24: "1547.57",
    },
    Mcap: "349.7116438753434",
    CoinName: "HFK / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "0x8767973acf382aadbce0429f6f09b4ac6aab7257",
    tokenName: "PNUTSNTA / WBNB",
    age: "6 minute(s) ago",
    chainName: "bsc",
    price: "0.00000243660124925815",
    volume: "35.702973",
    liquidity: "0.0",
    fdv: "487.32",
    totalTransactions: "3",
    pricePercentage: { m5: "0", h1: "0", h6: "0", h24: "0" },
    Mcap: "0.00008699390861403",
    CoinName: "PNUTSNTA / WBNB",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "D3FFkvaq88XBY5yfxTgDjBkEqvdwfayJcFu6Wor21t21",
    tokenName: "ROLLBIT / SOL",
    age: "6 minute(s) ago",
    chainName: "solana",
    price: "0.00000661315639691455",
    volume: "687.96371672",
    liquidity: "4162.0882",
    fdv: "6613.16",
    totalTransactions: "4",
    pricePercentage: { m5: "72.63", h1: "72.63", h6: "72.63", h24: "72.63" },
    Mcap: "0.004549611654071977",
    CoinName: "ROLLBIT / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "6M7WRJKRBj7VScPRdKYf1W6d9sVuu8A3i4FDaNA8Cfsu",
    tokenName: "SAM / SOL",
    age: "6 minute(s) ago",
    chainName: "solana",
    price: "0.0118693653530221",
    volume: "2302.83664",
    liquidity: "5508.9935",
    fdv: "118693654",
    totalTransactions: "10",
    pricePercentage: { m5: "846.9", h1: "846.9", h6: "846.9", h24: "846.9" },
    Mcap: "27.333209428485823",
    CoinName: "SAM / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "AXDa5uuDJr8TtvFsNJ2eUTvuu4ieoZTiL5F6cdnUB5CL",
    tokenName: "SQUID2 / SOL",
    age: "6 minute(s) ago",
    chainName: "solana",
    price: "0.0000500765581439457",
    volume: "266.7963759772",
    liquidity: "96063.3469",
    fdv: "100153",
    totalTransactions: "33",
    pricePercentage: { m5: "1.02", h1: "1.02", h6: "1.02", h24: "1.02" },
    Mcap: "0.013360244234216254",
    CoinName: "SQUID2 / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "0x2716c049b23868078b7aeff6456d211fc44990f4",
    tokenName: "TLSB / WBNB",
    age: "8 minute(s) ago",
    chainName: "bsc",
    price: "0.000815416180926688",
    volume: "207.6427086349",
    liquidity: "138979.8185",
    fdv: "81541.62",
    totalTransactions: "2",
    pricePercentage: { m5: "0", h1: "0.3", h6: "0.3", h24: "0.3" },
    Mcap: "0.16931522447234318",
    CoinName: "TLSB / WBNB",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "0x020b6b6a7b71a9ca6a1c093a763971344770f11f",
    tokenName: "KIKI / WBNB",
    age: "8 minute(s) ago",
    chainName: "bsc",
    price: "0.0000000000000224642047198456",
    volume: "1865.2719609966",
    liquidity: "5108.5644",
    fdv: "9434.97",
    totalTransactions: "56",
    pricePercentage: { m5: "0", h1: "1134.41", h6: "1134.41", h24: "1134.41" },
    Mcap: "4.190185119001548e-11",
    CoinName: "KIKI / WBNB",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "pos_0xa6d9c1ef731191755663aba362f631d489f4823b",
    tokenName: "EVM / USDT",
    age: "8 minute(s) ago",
    chainName: "polygon_pos",
    price: "0.602236619600995",
    volume: "0.249274359",
    liquidity: "239.3563",
    fdv: "6022366196",
    totalTransactions: "3",
    pricePercentage: { m5: "0", h1: "0.31", h6: "0.31", h24: "0.31" },
    Mcap: "0.15012214731736484",
    CoinName: "EVM / USDT",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "DvJxmsut7MVzAdB3zJtk2CoMFQuKqJnum8mcUeC8QZNg",
    tokenName: "TRUMP / SOL",
    age: "8 minute(s) ago",
    chainName: "solana",
    price: "0.0000270216079387421",
    volume: "4320.8175153941",
    liquidity: "242656.7263",
    fdv: "127002",
    totalTransactions: "43",
    pricePercentage: { m5: "4.8", h1: "4.8", h6: "4.8", h24: "4.8" },
    Mcap: "0.11675543687582914",
    CoinName: "TRUMP / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "CwXhuhiDznhJHJ9xhT5UdUUSHERkLBNRmqdmW43sm3gg",
    tokenName: "USDD / USDT",
    age: "8 minute(s) ago",
    chainName: "solana",
    price: "0.997834399856692",
    volume: "0.9978343999",
    liquidity: "9.9806",
    fdv: "99783440",
    totalTransactions: "1",
    pricePercentage: { m5: "0", h1: "0", h6: "0", h24: "0" },
    Mcap: "0.9956734895805789",
    CoinName: "USDD / USDT",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "8XZ4RwN1184BrQK7Xw4rPsDWzhxYjK7ZXuPnmgoNByyV",
    tokenName: "PEE / SOL",
    age: "8 minute(s) ago",
    chainName: "solana",
    price: "0.0298496186594366",
    volume: "66898.3695324454",
    liquidity: "35062.0853",
    fdv: "29849619",
    totalTransactions: "768",
    pricePercentage: {
      m5: "-34.36",
      h1: "-34.36",
      h6: "-34.36",
      h24: "-34.36",
    },
    Mcap: "1996.8908194815672",
    CoinName: "PEE / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "H953XPNB6B62dFWvMp1eRmfuuw34Pga3ZJYx5X8Dpump",
    tokenName: "AIGAME / SOL",
    age: "8 minute(s) ago",
    chainName: "solana",
    price: "0.0000981010667858092",
    volume: "18637.393144455",
    liquidity: "32908.87",
    fdv: "98101.07",
    totalTransactions: "358",
    pricePercentage: {
      m5: "1920.73",
      h1: "1920.73",
      h6: "1920.73",
      h24: "1920.73",
    },
    Mcap: "1.8283481495775624",
    CoinName: "AIGAME / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "GohfBAcRYHxpvZKAnRtFZvCiBQ3aBuY7rQ7HzkLGct1e",
    tokenName: "NAIA / SOL",
    age: "9 minute(s) ago",
    chainName: "solana",
    price: "0.0000034385806805313",
    volume: "84.7100609682",
    liquidity: "6014.7933",
    fdv: "3438.58",
    totalTransactions: "6",
    pricePercentage: { m5: "4.27", h1: "4.27", h6: "4.27", h24: "4.27" },
    Mcap: "0.00029128237909188106",
    CoinName: "NAIA / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "5ETwLgdX32tWn9obSjSbuopYkkePXLN3Tt3cZDBbWtf3",
    tokenName: "BURITO / SOL",
    age: "9 minute(s) ago",
    chainName: "solana",
    price: "1.08494991039598",
    volume: "14041.1844",
    liquidity: "27702.0732",
    fdv: "10849499104",
    totalTransactions: "14",
    pricePercentage: {
      m5: "849.03",
      h1: "849.03",
      h6: "849.03",
      h24: "849.03",
    },
    Mcap: "15233.981756633433",
    CoinName: "BURITO / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "5ANKbX79jmngruQbSesZQwJjKVfTY43gWC7o4KokQUBM",
    tokenName: "DHT / SOL",
    age: "9 minute(s) ago",
    chainName: "solana",
    price: "0.12393714266599",
    volume: "4602.30492",
    liquidity: "8459.3838",
    fdv: "1239371427",
    totalTransactions: "14",
    pricePercentage: {
      m5: "2213.94",
      h1: "2213.94",
      h6: "2213.94",
      h24: "2213.94",
    },
    Mcap: "570.3965214624276",
    CoinName: "DHT / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "CQPDXQ7u7xSyhtgadfdsQtZBC8DKzLCnAjwGYY7LWWAd",
    tokenName: "Trump BTC / SOL",
    age: "11 minute(s) ago",
    chainName: "solana",
    price: "0.0000142988497662461",
    volume: "4103.7121165864",
    liquidity: "159503.2555",
    fdv: "84363.21",
    totalTransactions: "59",
    pricePercentage: { m5: "8.94", h1: "8.94", h6: "8.94", h24: "8.94" },
    Mcap: "0.05867836303899273",
    CoinName: "Trump BTC / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "dTNx6Ki5cEmVASX6J1xTiRC32QbSfMu6gK9Yihuxaqf",
    tokenName: "MSS / SOL",
    age: "11 minute(s) ago",
    chainName: "solana",
    price: "0.000000000000216797976454118",
    volume: "21336.6894492844",
    liquidity: "0.0022",
    fdv: "0.00143087",
    totalTransactions: "33",
    pricePercentage: { m5: "-100", h1: "-100", h6: "-100", h24: "-100" },
    Mcap: "4.625751096834787e-9",
    CoinName: "MSS / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "7jsPEUYdErj4GdFGYRV9tnLZTs2ys4nmWC61C1A3PeMU",
    tokenName: "BELDY / SOL",
    age: "12 minute(s) ago",
    chainName: "solana",
    price: "0.0000000280841289909931",
    volume: "2625.7296420038",
    liquidity: "1.0954",
    fdv: "280.84",
    totalTransactions: "16",
    pricePercentage: { m5: "-100", h1: "-100", h6: "-100", h24: "-100" },
    Mcap: "0.00007374132996150886",
    CoinName: "BELDY / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "4tCNRD2EiphduBwnJpEcSgavK1sDFNQ5qyK32XZ8Ai86",
    tokenName: "WOOZOO / SOL",
    age: "14 minute(s) ago",
    chainName: "solana",
    price: "0.00000193037702370783",
    volume: "13281.1934871204",
    liquidity: "68.5925",
    fdv: "19303.77",
    totalTransactions: "16",
    pricePercentage: {
      m5: "-99.94",
      h1: "-99.94",
      h6: "-99.94",
      h24: "-99.94",
    },
    Mcap: "0.02563771075495529",
    CoinName: "WOOZOO / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "HyMBXpaqFBUMuKvDfKYuToDaUUh3VeSP2xiffo4WMnnc",
    tokenName: "HATU / SOL",
    age: "14 minute(s) ago",
    chainName: "solana",
    price: "0.000000137055782855423",
    volume: "5701.4714261293",
    liquidity: "0.0055",
    fdv: "1370.56",
    totalTransactions: "22",
    pricePercentage: { m5: "-100", h1: "-99.96", h6: "-99.96", h24: "-99.96" },
    Mcap: "0.0007814196297359762",
    CoinName: "HATU / SOL",
    score: 70,
    isDustCoin: false,
  },
  {
    tokenAddress: "yRh8yyRh61e6kDBWnqq3GMvV3wqgmjB8xq2zpq4Emnc",
    tokenName: "NYNM / SOL",
    age: "14 minute(s) ago",
    chainName: "solana",
    price: "0.0000284210228710568",
    volume: "3410.35198082",
    liquidity: "10008.3039",
    fdv: "28421.02",
    totalTransactions: "19",
    pricePercentage: {
      m5: "140.61",
      h1: "641.71",
      h6: "641.71",
      h24: "641.71",
    },
    Mcap: "0.09692569164523908",
    CoinName: "NYNM / SOL",
    score: 70,
    isDustCoin: true,
  },
  {
    tokenAddress: "9Vvgu1uHCh92zaGNS7QvFMJmBfjJE6KTuXTepVZ412VQ",
    tokenName: "TWN / SOL",
    age: "17 minute(s) ago",
    chainName: "solana",
    price: "0.0000000279625639076762",
    volume: "4354.9177468581",
    liquidity: "0.5839",
    fdv: "279.63",
    totalTransactions: "24",
    pricePercentage: { m5: "-100", h1: "-100", h6: "-100", h24: "-100" },
    Mcap: "0.00012177466580919287",
    CoinName: "TWN / SOL",
    score: 70,
    isDustCoin: false,
  },
];

export const coins = [
  {
    id: 1,
    image: "/image-1.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 2,
    image: "/image-2.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 3,
    image: "/image-3.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 2,
    image: "/image-2.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 1,
    image: "/image-1.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 3,
    image: "/image-3.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 2,
    image: "/image-2.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 1,
    image: "/image-1.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 1,
    image: "/image-1.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 2,
    image: "/image-2.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 3,
    image: "/image-3.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 1,
    image: "/image-1.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 3,
    image: "/image-3.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 2,
    image: "/image-2.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 3,
    image: "/image-3.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 2,
    image: "/image-2.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 3,
    image: "/image-3.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 1,
    image: "/image-1.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 1,
    image: "/image-1.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 2,
    image: "/image-2.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    id: 3,
    image: "/image-3.png", // Replace with the actual file path
    title: "Mind Bath(MB)",
    creator: "Quak",
    creatorProfileImage: "/profile.png",
    marketCap: "$73K",
    replies: 45,
    timeAgo: "23 min Ago",
    description:
      "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
];

export const followers = [
  {
    profileImage: "/follower.png",
    fullName: "John Doe",
    followers: 150,
  },
  {
    profileImage: "/follower.png",
    fullName: "Jane Smith",
    followers: 234,
  },
  {
    profileImage: "/follower.png",
    fullName: "Mike Ross",
    followers: 89,
  },
  {
    profileImage: "/follower.png",
    fullName: "Lucy Love",
    followers: 299,
  },
  {
    profileImage: "/follower.png",
    fullName: "Brian Jones",
    followers: 412,
  },
  {
    profileImage: "/follower.png",
    fullName: "Alice Green",
    followers: 185,
  },
  {
    profileImage: "/follower.png",
    fullName: "Charlie Brown",
    followers: 89,
  },
  {
    profileImage: "/follower.png",
    fullName: "Olivia Smith",
    followers: 120,
  },
  {
    profileImage: "/follower.png",
    fullName: "Liam Williams",
    followers: 375,
  },
  {
    profileImage: "/follower.png",
    fullName: "Ava Martin",
    followers: 250,
  },
  {
    profileImage: "/follower.png",
    fullName: "Sophia Davis",
    followers: 318,
  },
  {
    profileImage: "/follower.png",
    fullName: "Jackson White",
    followers: 222,
  },
  {
    profileImage: "/follower.png",
    fullName: "Mason Clark",
    followers: 211,
  },
  {
    profileImage: "/follower.png",
    fullName: "Isabella Walker",
    followers: 499,
  },
  {
    profileImage: "/follower.png",
    fullName: "Ethan Harris",
    followers: 100,
  },
  {
    profileImage: "/follower.png",
    fullName: "Amelia Young",
    followers: 600,
  },
  {
    profileImage: "/follower.png",
    fullName: "James Lewis",
    followers: 87,
  },
  {
    profileImage: "/follower.png",
    fullName: "Harper Scott",
    followers: 212,
  },
  {
    profileImage: "/follower.png",
    fullName: "Henry King",
    followers: 250,
  },
  {
    profileImage: "/follower.png",
    fullName: "Ella Adams",
    followers: 303,
  },
  {
    profileImage: "/follower.png",
    fullName: "Daniel Perez",
    followers: 178,
  },
  {
    profileImage: "/follower.png",
    fullName: "Grace Mitchell",
    followers: 420,
  },
  {
    profileImage: "/follower.png",
    fullName: "Sebastian Roberts",
    followers: 349,
  },
  {
    profileImage: "/follower.png",
    fullName: "Scarlett Walker",
    followers: 267,
  },
  {
    profileImage: "/follower.png",
    fullName: "Matthew Turner",
    followers: 158,
  },
  {
    profileImage: "/follower.png",
    fullName: "Victoria Lee",
    followers: 503,
  },
];

export const followings = [
  {
    profileImage: "/follower.png",
    fullName: "James Lewis",
    followers: 87,
  },
  {
    profileImage: "/follower.png",
    fullName: "Olivia Smith",
    followers: 120,
  },
  {
    profileImage: "/follower.png",
    fullName: "Brian Jones",
    followers: 412,
  },
  {
    profileImage: "/follower.png",
    fullName: "Lucy Love",
    followers: 299,
  },
  {
    profileImage: "/follower.png",
    fullName: "Isabella Walker",
    followers: 499,
  },
  {
    profileImage: "/follower.png",
    fullName: "Amelia Young",
    followers: 600,
  },
  {
    profileImage: "/follower.png",
    fullName: "Liam Williams",
    followers: 375,
  },
  {
    profileImage: "/follower.png",
    fullName: "Ava Martin",
    followers: 250,
  },
  {
    profileImage: "/follower.png",
    fullName: "Charlie Brown",
    followers: 89,
  },
  {
    profileImage: "/follower.png",
    fullName: "Sophia Davis",
    followers: 318,
  },
  {
    profileImage: "/follower.png",
    fullName: "Matthew Turner",
    followers: 158,
  },
  {
    profileImage: "/follower.png",
    fullName: "Ethan Harris",
    followers: 100,
  },
  {
    profileImage: "/follower.png",
    fullName: "Victoria Lee",
    followers: 503,
  },
  {
    profileImage: "/follower.png",
    fullName: "Grace Mitchell",
    followers: 420,
  },
  {
    profileImage: "/follower.png",
    fullName: "Harper Scott",
    followers: 212,
  },
  {
    profileImage: "/follower.png",
    fullName: "Sebastian Roberts",
    followers: 349,
  },
  {
    profileImage: "/follower.png",
    fullName: "Scarlett Walker",
    followers: 267,
  },
  {
    profileImage: "/follower.png",
    fullName: "Mike Ross",
    followers: 89,
  },
  {
    profileImage: "/follower.png",
    fullName: "John Doe",
    followers: 150,
  },
  {
    profileImage: "/follower.png",
    fullName: "Ella Adams",
    followers: 303,
  },
  {
    profileImage: "/follower.png",
    fullName: "Daniel Perez",
    followers: 178,
  },
  {
    profileImage: "/follower.png",
    fullName: "Mason Clark",
    followers: 211,
  },
  {
    profileImage: "/follower.png",
    fullName: "Jackson White",
    followers: 222,
  },
  {
    profileImage: "/follower.png",
    fullName: "Henry King",
    followers: 250,
  },
  {
    profileImage: "/follower.png",
    fullName: "Lucy Love",
    followers: 299,
  },
  {
    profileImage: "/follower.png",
    fullName: "Alice Green",
    followers: 185,
  },
  {
    profileImage: "/follower.png",
    fullName: "Liam Williams",
    followers: 375,
  },
];

export const notifications = [];

export const threads = [
  {
    userName: "shinobiTR",
    createdAt: "12:09 PM",
    image: "/follower.png",
    title: "Sadcoon",
    desc: "A memecoin is a type of cryptocurrency inspired by internet memes, jokes, or cultural trends. Often driven by social media hype and community enthusiasm, these coins typically lack inherent utility or technical innovation compared to major cryptocurrencies like Bitcoin or Ethereum. Popular examples include Dogecoin and Shiba Inu.",
  },
  {
    userName: "crypt0Ninja",
    createdAt: "1:15 PM",
    image: "/follower.png",
    title: "Crypto Crash",
    desc: "The cryptocurrency market has seen massive volatility in recent years, with major coins like Bitcoin and Ethereum experiencing significant price drops. This has led to a wave of uncertainty and fear among investors. However, many experts believe that this is a typical market correction, and the future of crypto remains promising.",
  },
  {
    userName: "blockchainFan",
    createdAt: "2:25 PM",
    image: "/follower.png",
    title: "DeFi Revolution",
    desc: "Decentralized Finance (DeFi) is a financial ecosystem built on blockchain technology that enables individuals to perform financial transactions without intermediaries such as banks. With platforms like Uniswap and Compound, users can trade, lend, borrow, and earn interest on digital assets. DeFi has the potential to disrupt traditional banking systems and democratize finance.",
  },
  {
    userName: "crypt0Queen",
    createdAt: "3:45 PM",
    image: "/follower.png",
    title: "NFT Craze",
    desc: "Non-Fungible Tokens (NFTs) have taken the art world by storm, offering artists a new way to monetize their digital creations. NFTs represent unique assets on the blockchain, and their ownership is verified and traceable. Some high-profile NFT sales have reached millions of dollars, sparking widespread interest in the space. However, some argue that NFTs are a bubble that will eventually burst.",
  },
  {
    userName: "techInvestor",
    createdAt: "4:30 PM",
    image: "/follower.png",
    title: "Ethereum 2.0",
    desc: "Ethereum 2.0 is the next major upgrade to the Ethereum blockchain, transitioning from a Proof-of-Work (PoW) to a Proof-of-Stake (PoS) consensus mechanism. This upgrade aims to improve scalability, security, and energy efficiency. The transition is expected to reduce Ethereum's energy consumption by over 99% and pave the way for more decentralized applications (dApps) and smart contracts.",
  },
  {
    userName: "altcoinGuru",
    createdAt: "5:50 PM",
    image: "/follower.png",
    title: "The Rise of Altcoins",
    desc: "While Bitcoin and Ethereum dominate the crypto market, altcoins (alternative cryptocurrencies) are gaining popularity. Coins like Binance Coin (BNB), Cardano (ADA), and Solana (SOL) are showing strong growth, attracting investors who believe in their unique features and potential. The rise of altcoins is fueling competition and innovation in the crypto space.",
  },
  {
    userName: "futureTechie",
    createdAt: "6:05 PM",
    image: "/follower.png",
    title: "Web3 and the Decentralized Internet",
    desc: "Web3 is an emerging movement that aims to create a decentralized version of the internet using blockchain technology. In Web3, users have control over their data and digital identities, and decentralized applications (dApps) run on blockchain networks rather than centralized servers. The goal of Web3 is to empower individuals and create a more open and transparent internet.",
  },
  {
    userName: "blockchainFanatic",
    createdAt: "7:20 PM",
    image: "/follower.png",
    title: "Bitcoin Halving Explained",
    desc: "Bitcoin halving is an event that occurs every four years, reducing the block reward that miners receive by half. This mechanism is built into Bitcoin’s code to control its inflation rate and ensure that only 21 million Bitcoins will ever exist. Historically, Bitcoin halvings have been associated with price surges, as the reduced supply of new coins creates scarcity in the market.",
  },
  {
    userName: "coinTrader23",
    createdAt: "8:10 PM",
    image: "/follower.png",
    title: "Stablecoins: A Safer Bet?",
    desc: "Stablecoins are cryptocurrencies that are pegged to stable assets like the US Dollar or gold to reduce price volatility. These coins, such as Tether (USDT) and USD Coin (USDC), are commonly used as a hedge against the high volatility of other cryptocurrencies. They provide a safe haven for traders and investors looking to park their funds while still being part of the crypto ecosystem.",
  },
  {
    userName: "SatoshiFan",
    createdAt: "9:25 PM",
    image: "/follower.png",
    title: "The Impact of Blockchain on Supply Chain",
    desc: "Blockchain technology is revolutionizing the supply chain industry by providing transparent, traceable, and secure methods of tracking products from origin to destination. This increases accountability, reduces fraud, and ensures the quality and authenticity of goods. Major companies like IBM and Walmart are already using blockchain to improve their supply chain management.",
  },
];

export const advanceTable = [
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.00,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
  {
    image: "/advance-slider-image.png",
    coinName: "CIRCUIT AI",
    placeholder: "AeroCircuit",
    completePercentage: 7.06,
    mc: 76.2,
    v: 11.8,
    t10Percentage: 0.58,
    users: 1,
    dhPercentage: 14,
    target: 1,
    createdAt: "2s Ago",
    holders: [
      {
        name: "user 12345",
        own: 0.01,
        sol: 6.7,
        uPnl: -4.34,
        rPnl: 0.0,
      },
      {
        name: "user 23456",
        own: 0.09,
        sol: 5.9,
        uPnl: 0.0,
        rPnl: -2.99,
      },
      {
        name: "user 34567",
        own: 0.1,
        sol: 7,
        uPnl: -5.09,
        rPnl: 0.0,
      },
    ],
    threads: {
      name: "shinobiTR",
      image: "/follower.png",
      message: "This seems interesting",
      createdAt: "0s",
    },
    quickBay: 0.01,
  },
];
